export * from './random-symbol-color.module';
